import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3e189e7c")

_pushScopeId("data-v-3e189e7c")
const _hoisted_1 = { class: "toggle-with-text" }
const _hoisted_2 = { class: "title-wrap" }
const _hoisted_3 = { class: "toggle-title" }
const _hoisted_4 = {
  key: 0,
  class: "toggle-description"
}
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Toggle = _resolveComponent("Toggle")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _createVNode("p", _hoisted_3, _toDisplayString(_ctx.title), 1),
      (_ctx.description)
        ? (_openBlock(), _createBlock("p", _hoisted_4, _toDisplayString(_ctx.description), 1))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_Toggle, { size: "size-m" })
  ]))
})